// Manages focused-application state for the BPMN application focus mode.
// Module-level ref mirrors the pattern used by focusedEntityId in entity-focus.ts.
import { ref } from "vue";

const focusedApplicationId = ref<string | null>(null);

const setApplicationFocus = (applicationId: string): void => {
    focusedApplicationId.value = applicationId;
};

const clearApplicationFocus = (): void => {
    focusedApplicationId.value = null;
};

export { focusedApplicationId, setApplicationFocus, clearApplicationFocus };
